export const PesertaHeader = {
    headline: 'Sign Up Peserta',
};

export const PerusahaanHeader = {
    headline: 'Sign Up Perusahaan',
};